<template>
  <div class="cotainer">
	<a-modal :title="title[type]" :visible="industryVisible" @cancel="closeVisible"
					width="50%">
                    <!-- 新增行业 -->
                    <template slot="footer" v-if="type==0">
						<a-button key="back" @click="closeVisible"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="industruPut">确定</a-button>
					</template>
                    <!-- 编辑行业 -->
					<template slot="footer" v-if="type==1">
						<a-button key="back" @click="closeVisible"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="industryResevr">保存</a-button>
					</template>
                    <!-- 行业详情 -->
					<template slot="footer" v-if="type==12">
						<a-button key="back" @click="industryVisible = false"> 取消 </a-button>
					</template>
					<a-form-model :model="industryForm"  ref="industryFormRef" :label-col="{ span: 6 }"
						:wrapper-col="{ span: 18 }">
						<a-row>
							<a-col :span="12">
							    <a-form-model-item label="所属项目">
									<span>{{programName }}</span>
							    </a-form-model-item>
							</a-col>
						</a-row>
						<a-row> 
							<a-col :span="12">
								<a-form-model-item label="行业编号" v-if="type==1 || type==0 " prop="industryCode" :rules="{
							  required: true,
							  message: '请输入行业编号',
							  trigger: 'change',
							}">
									<a-input v-model="industryForm.industryCode" placeholder="行业编号" :disabled="type==1"/>
								</a-form-model-item>
								<a-form-model-item label="行业编号" v-else>
									<span>{{industryForm.industryCode}}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="行业名称" prop="industryName" v-if="type==1 || type==0" :rules="{
							  required: true,
							  message: '请输入行业名称',
							  trigger: 'change',
							}">
							   <a-input v-model="industryForm.industryName" placeholder="行业名称" />
								</a-form-model-item>
									<a-form-model-item label="行业名称" v-else>
									<span>{{industryForm.industryName}}</span>
								</a-form-model-item>
								
							</a-col>
						</a-row>
						<a-row v-if="type==2">
							<a-col :span="12">
								<a-form-model-item label="创建时间" >
									<span>{{industryForm.createTime}}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="更新时间" >
									<span>{{industryForm.updateTime}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
				</a-modal>
  </div>
</template>

<script>
import {
  delete_factor,
  getFactorDetail,
  getUserListDetail,
  industryInfo,
  industryInfo_post,
  postInfo,
  addPostWithHarmFactor,
  editPostWithHarmFactor,
  industryInfo_details,
  industryInfo_put,
  postInfo_details,
  postInfo_put,
  baseFactor,
  getCategoryTree,
  subCategory,
  baseFactor_add,
  factor_details,
  editFactors_put,
  factor_list,
  deleteIndustryInfo,
  deleteFactor,
  getUserList,
} from '@/api/Industry'
import { getCategoryList} from '@/api/surrounding'
export default {
    props: [
        'type'
    ],
    data() {
        return {
            title: [
                '行业列表-新增行业',
                '行业列表-编辑行业',
                '行业列表-详情',
            ],
            industryVisible: false,
            programName: '',
            industryForm: {
                industryCode: '',
                industryName: ''

            }

        }
    },
    methods: {
        //获取当前页面列表
        init(id) {
           this.$nextTick((res) => {
          console.log(this.type, 'this.type ======================')
             if(this.type == 2 || this.type == 1) {
                
                 industryInfo_details(id).then((res1) => {
               if(res1.code==200) {
                  this.industryForm = res1.data
                  console.log( this.industryForm , ' this.industryForm  this.industryForm  this.industryForm  this.industryForm ')
                  this.getProgram()

                  }
               })
               this.industryVisible = true 
               
             } else {
                this.industryForm = {}
                this.getProgram()
                this.industryVisible = true

             }
             })
           

        },
        // 获取项目
       getProgram() {
        getCategoryList().then(res =>{
        if(res.code == 200) {
            console.log('11111111111111111111111')
            res.data.forEach(item => {
                if (item.id == 1) {
                 this.programName =  item.categoryName
                }
            })
        } else {
            this.$message.error(res.msg)
        }
        
    })
        },
        // 关闭弹窗
        closeVisible() {
            this.industryVisible = false
            this.$refs.industryFormRef.resetFields()
            

        },
        // 编辑保存项目
        industryResevr() {
              this.$refs.industryFormRef.validate((valid) => {
        if (valid) {
          Object.assign(this.industryForm, {
            projectId: 1
          })
          industryInfo_put(this.industryForm).then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功')
              this.industryVisible = false
              this.$refs.industryFormRef.resetFields()
            //   刷新列表
            this.$emit('getIndustryList')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })

        },
    industruPut() {
      this.$refs.industryFormRef.validate((valid) => {
        if (valid) {
          industryInfo_post({
            ownProject: '职业病危害因素检测与评价',
            projectId: 1,
            industryCode: this.industryForm.industryCode,
            industryName: this.industryForm.industryName,
          }).then((res) => {
            if (res.code == 200) {
              this.$refs.industryFormRef.resetFields()
              this.industryForm = {}
              this.$message.success('新增成功')
              this.industryVisible = false
              this.$emit('getIndustryList')
            } else {
              this.$message.success(res.msg)
            }
          })
        }
      })
        }
    }
    

}
</script>

<style>

</style>